import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';

import { EDUVideo } from '../models';

export interface EDUVideoApi {
    items: EDUVideo[];
    total_count: number;
}

@Injectable({
    providedIn: 'root'
})
export class EDUVideoService {
    private _eduVideoRoute = '/api/edu-videos/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    public videoBeingViewed: any = {};

    videoCategoryValue = new BehaviorSubject(this.currentVideoCategory);

    set currentVideoCategory(value) {
        this.videoCategoryValue.next(value); // this will make sure to tell every subscriber about the change.
        localStorage.setItem('video-category', value);
    }

    get currentVideoCategory() {
        let categoryInStorage = localStorage.getItem('video-category');
        if (!categoryInStorage || categoryInStorage === undefined) categoryInStorage = 'view-all';
        return categoryInStorage;
    }

    constructor(
        private httpClient: HttpClient,
    ) { }


    setVideoToBeViewed(_eduVideo: any) {
        this.videoBeingViewed = _eduVideo;
    }


    getVideoToBeViewed() {
        return this.videoBeingViewed;
    }


    setVideoCategoryToLocalStorage(_category) {
      // localStorage.setItem('video-category', JSON.stringify(_category));
      this.currentVideoCategory = _category; // this change will broadcast to every subscriber like below component
    }


    get(): Observable<any[]> {
        return this.httpClient.get<any[]>(this._eduVideoRoute);
    }


    getById(_eduVideoId: string): Observable<any> {
        return this.httpClient.get<any>(this._eduVideoRoute + _eduVideoId);
    }


    getByFileName(eduVideoFilename: string): Observable<any> {
        return this.httpClient.get<any>(this._eduVideoRoute + 'by-filename/' + eduVideoFilename);
    }


    getAllByCategory(videoCategory: string): Observable<EDUVideo[]> {
        return this.httpClient.get<EDUVideo[]>(this._eduVideoRoute + 'all-by-category/' + videoCategory);
    }


    create(_eduVideo: EDUVideo): Observable<any> {
        return this.httpClient.post<any>(this._eduVideoRoute, JSON.stringify(_eduVideo), this.headerOptions);
    }


    selectAllSearch(searchTerms): Observable<EDUVideoApi> {
        searchTerms['selectAll'] = true;
        return this.httpClient.post<EDUVideoApi>(this._eduVideoRoute + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
    }


    getCustomDatasource(searchParams, sortField, sortDirection, pageNumber: number, pageSize: number): Observable<EDUVideoApi> {
        searchParams['selectAll'] = false;
        searchParams.sortField = (sortField && sortField !== '') ? sortField : 'createdAt';
        searchParams.sortOrder = (sortDirection && sortDirection !== '') ? sortDirection : 'desc';
        searchParams.pageNumber = (pageNumber && pageNumber !== undefined) ? pageNumber : 0;
        searchParams.pageSize = (pageSize && pageSize !== undefined) ? pageSize : 10;

        return this.httpClient.post<EDUVideoApi>(this._eduVideoRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions); 
    }


    update(_eduVideo: EDUVideo): Observable<any> {
        return this.httpClient.put<any>(this._eduVideoRoute + _eduVideo._id, JSON.stringify(_eduVideo), this.headerOptions);
    }


    markDelete(_id: string): Observable<any> {
        return this.httpClient.put(this._eduVideoRoute + 'mark-deleted/' + _id, this.headerOptions);
    }
}